import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
  Renderer2,
} from '@angular/core';
import { InvoiceService } from '../../../../services/invoice.service';
import { ProductsService } from '../../../../services/products.service';
import { LookupService } from '../../../../services/lookup.service';
import { HelpersService } from '../../../../services/helpers.service';
import { SpecialOrdersService } from '../../../../services/specialorders.service';
import { InventoryService } from '../../../../services/inventory.service';
import { AppConfig } from '../../../../app.config';
import { UserService } from '../../../../services/user.service';
import { PosIntegrationService } from '../../../../services/pos-integration.service';
import { ConfirmationService } from 'primeng/api';
import { WriteLogsService } from '../../../../services/write-logs.service';
import { PageViews } from '../../../../enums/page-views.enum';
import { Pos } from '../../../../enums/pos.enum';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AutoComplete } from 'primeng/autocomplete';
import { PartnerService } from 'src/app/services/partner.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { CouponsService } from '../../../../services/coupons.service';
import { InvoiceOptionsService } from '../../../../services/invoice-options.service';
import { JoyrideService } from 'ngx-joyride';
import { Inplace } from 'primeng/inplace';
import moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';

const minSearchCharLen = 2;

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuoteComponent implements OnInit {
  @Input() jobcard;
  @Input() partnerID;
  @Input() messageService;
  @Input() jobApproved;
  @ViewChild('quantityComponent') quantityComponent: ElementRef;
  @ViewChild('productSearchComponent') productSearchComponent: AutoComplete;
  @ViewChild('lineItemProductSearchComponent')
  lineItemProductSearchComponent: AutoComplete;

  public invoice: any = {};
  public products: any = [];
  public searchResult: any = [];
  public gearTypes: any = [];
  public editLine: any = {};
  public productSearch: any = '';
  public editing: boolean = false;
  public updatingQuote: boolean = false;
  public sendingToPOS: boolean = false;
  public currencySymbol = '';
  public VATInclusive = true;
  public VATRate = 0.15;
  public itemsSyncdToPOS = 0;
  public approved = false;
  public disablePOS = false;
  public allowDiscount = false;
  public discountType = '';
  public discounts: any = [];

  public lightSpeedDiscounts: any = [];
  public sent = false;
  public isDev: boolean = true;
  public syncingPOS: boolean = false;
  public POSName = 'POS';
  public partner: any;
  public tourBusy: boolean = false;
  public discountCode: string = '';
  shortCode: any;
  public popupWindow: any;
  public searchExternalFlag: boolean = false;
  public searchExternalValue: string = '';
  public canDoExternalSearch: boolean = false;
  public invoiceOptions: any = [];
  public invoiceOptionsBusy: boolean = false;
  public showInvoiceOptions = false;
  public gettingInventory = false;
  public needSpecialOrder = false;
  public selectItemsForSpecialOrder = false;
  public specialOrderItems: any = [];
  public showTakingTooLong: boolean = false;
  public getQuantitiesLocked: boolean = false;
  public canManageProducts: boolean = false;
  public showProductPanel: boolean = false;
  public loading: boolean = true;

  public sendToThirdPartyOnly: boolean = false;

  public priceGroups: any = [];
  public priceGroup: any;

  public hasCouponsSetup = false;
  public useWorkOrdersForWorkshop: boolean = false;

  constructor(
    public invoiceService: InvoiceService,
    public productsService: ProductsService,
    public lookupService: LookupService,
    public helpersService: HelpersService,
    public userService: UserService,
    private confirmationService: ConfirmationService,
    private writeLogsService: WriteLogsService,
    private translate: TranslateService,
    private posIntegrationService: PosIntegrationService,
    public partnerService: PartnerService,
    public serviceRequest: ServiceRequestService,
    private couponsService: CouponsService,
    private joyrideService: JoyrideService,
    private specialOrdersService: SpecialOrdersService,
    private invoiceOptionsService: InvoiceOptionsService,
    private inventoryService: InventoryService,
    public appConfig: AppConfig,
    private renderer: Renderer2,
  ) {
    this.products = this.helpersService.getProductData();
  }

  ngOnInit() {
    this.getItemPricesGroups();
    setTimeout(() => {
      //  this.productSearchComponent.focusInput();
      if (
        this.productSearchComponent.inputEL &&
        this.productSearchComponent.inputEL.nativeElement
      ) {
        const inputElement = this.productSearchComponent.inputEL.nativeElement;
        this.renderer.selectRootElement(inputElement).focus();
      }
    }, 500);
    var partnerData = this.helpersService.getPartnerData();
    this.partner = partnerData;

    if (this.partner.HasCouponsSetup) {
      this.hasCouponsSetup = true
    }

    if (this.partner.POSSystemID === 17)
      this.hasCouponsSetup = false;

    this.canDoExternalSearch =
      (this.partner.POSSystemID === 6 || this.partner.POSSystemID === 9) &&
      this.partner.ExternalProductIntegrationsPartnerLinks &&
      this.partner.ExternalProductIntegrationsPartnerLinks.length > 0;

    this.currencySymbol = partnerData.CurrencySymbol;
    this.VATInclusive = partnerData.VATInclusive;
    this.VATRate = partnerData.VATRate;

    this.discountCode =
      this.jobcard.CouponCode || this.jobcard.ExternalVoucherCode;

    this.POSName =
      partnerData.POSSystemID === 3
        ? 'POS'
        : partnerData.POSSystemID === 6
          ? 'Lightspeed R'
          : partnerData.POSSystemID === 8
            ? 'Xero'
            : partnerData.POSSystemID === 4
              ? 'Sage'
              : partnerData.POSSystemID === 9
                ? 'Shopify'
                : partnerData.POSSystemID === 13
                  ? 'Citrus Lime'
                  : partnerData.POSSystemID === 14
                    ? 'EPOSNow'
                    : partnerData.POSSystemID === 15
                      ? 'Wilmar'
                      : partnerData.POSSystemID === 16
                        ? 'POS (Invoice)'
                        : partnerData.POSSystemID === 17
                          ? 'Square'
                          : partnerData.POSSystemID === 19
                            ? 'Heartlands'
                            : 'POS';

    this.partnerService
      .getOrganisationShortCode(partnerData.ID)
      .subscribe((res) => {
        this.shortCode = res;
      });

    this.allowDiscount = partnerData.AllowDiscount || false;
    this.discountType =
      partnerData.POSSystemID === 6
        ? 'PERCENTAGE'
        : partnerData.POSSystemID === 3 ||
          partnerData.POSSystemID === 8 ||
          partnerData.POSSystemID === 9 ||
          partnerData.POSSystemID === 14 ||
          partnerData.POSSystemID === 11 ||
          partnerData.POSSystemID === 12 ||
          partnerData.POSSystemID === 13 ||
          partnerData.POSSystemID <= 0
          ? 'AMOUNT'
          : 'NONE';
    if (this.discountType === 'PERCENTAGE') {
      this.getLightSpeedDiscounts();
    }
    this.allowDiscount = partnerData.AllowDiscount || false;
    //this.discountType =
    //  partnerData.POSSystemID === 6
    //    ? "PERCENTAGE"
    //    : partnerData.POSSystemID === 3 || partnerData.POSSystemID === 8
    //      ? "AMOUNT"
    //      : "NONE";

    //First get all the invoice items without inventory, seems on big quotes, this sometimes takes a while to fetch, especially if there is a delay on the POS side
    this.getInvoice(() => {
      this.getInvoice(() => {
        return;
      }, true);
      return;
    }, false, true);

    this.getGearTypes();
    this.writeLogsService
      .writeLog(PageViews.QUOTE_TAB, this.jobcard.ID)
      .subscribe((result) => { });
    if (this.partner.AllowMultipleQuoteOptions) {
      this.checkQuoteOptions();
    }
    this.checkIntegration();

    //if (this.helpersService.showTour('Quote')) {
    //  setTimeout(() => {
    //    this.tourBusy = true;
    //    this.joyrideService.startTour({
    //      steps: [
    //        'quoteStepOne',
    //        'quoteStepTwo',
    //        'quoteStepThree',
    //        'quoteStepFour',
    //      ],
    //      themeColor: '#151A2A',
    //    });
    //  }, 500);
    //}

    if (this.jobcard.ThirdPartyID != null) {
      this.sendToThirdPartyOnly = true;
    }
  }

  tourDone() {
    this.tourBusy = false;
    this.helpersService.tourComplete('Quote');
  }

  checkIntegration() {
    if (
      this.appConfig
        .getSupportedPOSSystems()
        .map((x) => {
          return x.POSID;
        })
        .indexOf(this.partner.POSSystemID) > -1
    ) {
      this.posIntegrationService
        .checkPOSIntegration(this.partner.ID, this.partner.POSSystemID)
        .subscribe(
          (result) => {
            this.canManageProducts = false;
          },
          (err) => {
            this.canManageProducts = true;
          },
        );
    } else if (this.partner.POSSystemID <= 0) {
      this.canManageProducts = true;
    }
  }

  getGearTypes() {
    this.lookupService.getGearTypes().subscribe((gearTypes) => {
      this.gearTypes = gearTypes;
    });
  }

  getLightSpeedDiscounts() {
    this.invoiceService.getDiscounts(this.partnerID).subscribe((discounts) => {
      this.lightSpeedDiscounts = discounts;
      this.discounts.push({ label: '0%', value: 0 });
      if (discounts && discounts.length > 0) {
        discounts.forEach((discount) => {
          this.discounts.push({
            label: discount.Name,
            value: parseInt(discount.ID),
          });
        });
      }
    });
  }

  checkQuoteOptions() {
    this.invoiceOptionsBusy = true;
    this.invoiceOptionsService.getInvoiceOptions(this.jobcard.ID).subscribe(
      (invoiceOptions) => {
        this.invoiceOptionsBusy = false;
        this.invoiceOptions = invoiceOptions;
      },
      (err) => {
        this.invoiceOptionsBusy = false;
      },
    );
  }

  getApprovedQuoteOption() {
    return this.invoiceOptions
      .filter((x) => {
        return x.approvalStatus === 10;
      })
      .pop();
  }

  updateQuoteOptions(invoiceOptions) {
    this.invoiceOptions = invoiceOptions;
  }

  manageInvoicePOSExtras() {
    this.loading = true;
    this.invoiceService
      .manageInvoicePOSExtras(this.invoice.ID)
      .subscribe((invoice) => {
        this.handleGetInvoice(null, invoice);
        this.loading = false;
      });
  }

  getInvoice(callback, getInventory: boolean = false, initialLoad: boolean = false) {
    this.loading = getInventory;
    this.invoiceService
      .getInvoiceV2(this.jobcard.ID, getInventory)
      .subscribe((invoice) => {
        this.handleGetInvoice(callback, invoice);
        if (getInventory) this.loading = false;
        if(initialLoad && this.invoice.WorkOrderID){
          this.manageInvoicePOSExtras();
        }
      });
  }

  handleGetInvoice(callback, invoice) {
    if (invoice !== null) {
      var originalInvoice = JSON.parse(JSON.stringify(this.invoice));
      this.invoice = invoice;

      if(invoice.ServiceStatusID && invoice.ServiceStatusID !== this.jobcard.StatusID){
        this.jobcard.StatusID = invoice.ServiceStatusID;
      }

      if (this.partner.POSSystemID === 6 && this.partner.UseWorkOrders
        && (!this.invoice.ExternalKey || this.invoice.ExternalKey === '0' || !!this.invoice.WorkOrderID)
      ) {
        this.useWorkOrdersForWorkshop = true;
      } else if (this.partner.POSSystemID === 6 && !this.partner.UseWorkOrders && this.invoice.WorkOrderID) {
        //This is for when a store might have disabled work orders after the quote was created, we still linked to the work order to show the workorder UI
        this.useWorkOrdersForWorkshop = true;
      }

      for (var i = 0; i < this.invoice.LineItems.length; i++) {
        this.invoice.LineItems[i].LineItemNoteUpdate =
          this.invoice.LineItems[i].LineItemNote;
        if (
          originalInvoice &&
          originalInvoice.LineItems &&
          originalInvoice.LineItems.length > 0
        ) {
          var origLineItem = originalInvoice.LineItems.filter((x) => {
            return x.ID == this.invoice.LineItems[i].ID;
          }).pop();
          if (
            origLineItem != null &&
            origLineItem.LineItemNoteUpdate !=
            this.invoice.LineItems[i].LineItemNoteUpdate
          ) {
            console.log(origLineItem);
            this.invoice.LineItems[i].LineItemNoteUpdate =
              origLineItem.LineItemNoteUpdate;
          }
        }

        if (this.invoice.LineItems[i].StockOnHand == undefined)
          this.invoice.LineItems[i].StockOnHand = '-';
        /*if (this.invoice.LineItems[i].StockOnHand < 0)
                                                                  this.invoice.LineItems[i].StockOnHand = "-";*/
      }

      if (this.invoice.StatusID < 40) {
        this.gettingInventory = true;

        var itemsNeedingOrder = invoice.LineItems.filter((x) => {
          return (
            x.Note === 'ORDER OFFERED' &&
            x.SpecialOrderStatus === null &&
            (x.StockOnHand <= 0 || x.StockOnHand == '-')
          );
        });

        if (itemsNeedingOrder && itemsNeedingOrder.length > 0) {
          this.needSpecialOrder = true;
        } else {
          this.needSpecialOrder = false;
        }

        for (var i = 0; i < this.invoice.LineItems.length; i++) {
          for (var x = 0; x < invoice.LineItems.length; x++) {
            if (this.invoice.LineItems[i].ID == invoice.LineItems[x].ID) {
              this.invoice.LineItems[i].StockOnHand =
                invoice.LineItems[x].StockOnHand;
            }

            if (this.invoice.LineItems[i].StockOnHand == '0')
              this.invoice.LineItems[i].StockOnHand = '-';
            if (this.invoice.LineItems[i].StockOnHand < 0)
              this.invoice.LineItems[i].StockOnHand = '-';
          }
        }
        this.gettingInventory = false;
      }

      /*if (invoice && invoice.OrderNeeded === true) {
                                                  this.promptSpecialOrder();
                                                }*/

      this.editing = false;
      this.updatingQuote = false;
      this.itemsSyncdToPOS = this.invoice.LineItems.filter((lineItem) => {
        return lineItem.ExternalKey !== null && lineItem.ExternalKey.length > 0;
      }).length;
      this.disablePOS =
        this.invoice.LineItems.findIndex((x) => !x.Approved) > -1 &&
        invoice.SentApproval;
      if (callback !== null) {
        callback();
      }

      var itemsBeingEdited =
        originalInvoice &&
        originalInvoice.LineItems &&
        originalInvoice.LineItems.filter((x) => {
          return x.edit;
        });
      if (itemsBeingEdited && itemsBeingEdited.length > 0) {
        var invoiceLineItemIDS = this.invoice.LineItems.map((x) => {
          return x.ID;
        });
        var index = invoiceLineItemIDS.indexOf(itemsBeingEdited[0].ID);
        this.invoice.LineItems[index].Quantity = itemsBeingEdited[0].Quantity;
        this.invoice.LineItems[index].UnitPrice = itemsBeingEdited[0].UnitPrice;
        this.invoice.LineItems[index].UnitPrice_IncludingTax =
          itemsBeingEdited[0].UnitPrice_IncludingTax;
        this.invoice.LineItems[index].Discount = itemsBeingEdited[0].Discount;
        this.invoice.LineItems[index].DiscountID =
          itemsBeingEdited[0].DiscountID;
        this.invoice.LineItems[index].edit = true;
        this.editLine = this.invoice.LineItems[index];
        this.editing = true;
      }
    } else {
      this.editing = false;
      this.updatingQuote = false;
      if (callback !== null) {
        callback();
      }
    }
  }

  exactMatch(query, item) {
    return (
      query &&
      query.length > 0 &&
      (query === item.SKU ||
        query === item.ManufacturerSKU ||
        query === item.SystemSKU ||
        query === item.EAN ||
        query === item.UPC)
    );
  }

  limitResults() {
    if (!this.searchExternalFlag) {
      this.searchResult = this.searchResult.filter(function (product) {
        return product.ExternalProductID !== '';
      });
      setTimeout(() => {
        this.getQuantitiesLocked = false;
      }, 200);
    } else {
      this.searchResult = this.searchResult.filter(function (product) {
        return product.ExternalProductID === '';
      });
      setTimeout(() => {
        this.getQuantitiesLocked = false;
      }, 200);
    }
  }

  getSearchResultQuantities(event, resetSearch = false) {
    if (!this.getQuantitiesLocked) {
      if (this.searchResult && this.searchResult.length < 100) {
        var results = resetSearch
          ? JSON.parse(JSON.stringify(this.searchResult))
          : this.searchResult;
        if (this.partner.POSSystemID === 6) {
          this.productsService
            .GetInventoryOnHandForProducts(
              this.partnerID,
              results.map((x) => {
                return x.SKU;
              }),
            )
            .subscribe((queryResults) => {
              queryResults.forEach((stockItem) => {
                var searchItem = results
                  .filter((x) => {
                    return x.SKU === stockItem.SKU;
                  })
                  .pop();
                if (searchItem !== null) {
                  searchItem.StockOnHand = stockItem.isInventory
                    ? stockItem.QOH
                    : null;
                }
              });
              if (resetSearch) {
                this.searchResult = [];
              }
              this.searchResult = results.sort((x, y) => {
                if (x.StockOnHand < y.StockOnHand) return 1;
                if (x.StockOnHand > y.StockOnHand) return -1;
                return 0;
              });
              //         this.productSearchComponent.focusInput();
              if (
                this.productSearchComponent.inputEL &&
                this.productSearchComponent.inputEL.nativeElement
              ) {
                const inputElement =
                  this.productSearchComponent.inputEL.nativeElement;
                this.renderer.selectRootElement(inputElement).focus();
              }
              this.productSearchComponent.show();
            });
        }
      }
    } else {
      setTimeout(() => {
        this.getSearchResultQuantities(resetSearch);
      }, 1000);
    }

    event.preventDefault();
  }

  canGetQuantities() {
    if (
      this.partner.POSSystemID === 6 &&
      !this.searchExternalFlag &&
      this.productSearch &&
      this.productSearch.length > 3 &&
      this.searchResult.length > 0 &&
      this.searchResult.length < 100
    ) {
      return 'YES';
    } else if (
      this.partner.POSSystemID === 6 &&
      !this.searchExternalFlag &&
      this.productSearch &&
      this.productSearch.length > 3 &&
      this.searchResult.length >= 100
    ) {
      return 'NARROW SEARCH';
    } else {
      return 'NO';
    }
  }

  lockQuantitySearch(event) {
    if (event.keyCode !== 13) {
      this.getQuantitiesLocked = true;
    }
    event.preventDefault();
  }

  searchProducts(event) {
    if (event.query === null || event.query === undefined) return;

    this.searchExternalValue = event;
    //Return no resilts for 1 letter... this can slow browser allot. Might want to increase this if too many results get shown
    if (
      (event.query &&
        event.query.length < minSearchCharLen &&
        event.originalQuery === undefined) ||
      (event.originalQuery !== undefined &&
        event.originalQuery.length < minSearchCharLen)
    ) {
      this.searchResult = [];
      return;
    }

    //if the external flag is on, dont try search the cache, go straight to the API as there is logic to direct that to the external products API.
    if (this.searchExternalFlag) {
      this.searchAPI(event);
      return;
    }

    if (
      this.partner.POSSystemID === 6 &&
      event.query &&
      event.query.indexOf('21') == 0 &&
      (event.query.length === 2 ||
        (event.query.length > 2 &&
          parseInt(event.query.substring(2, 100)) == 0))
    ) {
      return;
    }

    //Try search the SKU type fields 1st
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        //product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (!!product.SystemSKU &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (!!product.ManufacturerSKU &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1) ||
        (!!product.UPC &&
          product.UPC.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.EAN &&
          product.EAN.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.CustomSKU &&
          product.CustomSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1)
      );
    });

    //Use a different search to filter the Name field, this now can search the field with words in any order.
    var nameResults = this.filterList(event.query, this.products);
    if (nameResults && nameResults.length > 0) {
      nameResults.forEach((result) => {
        if (
          results.filter((x) => {
            return x.ID == result.ID;
          }).length === 0
        ) {
          results.push(result);
        }
      });
    }

    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.FoundInPOS = true;
      product.OriginalUnitPrice = JSON.parse(JSON.stringify(product)).UnitPrice;
      delete product.PartnerID;
      return product;
    });

    if (
      this.partner.AllowExactMatchingOnQuote &&
      results.length === 1 &&
      this.exactMatch(event.query, results[0])
    ) {
      this.addLineItemAuto({ ...results[0] });
    } else if (results.length > 0) {
      this.searchResult = results;
      this.limitResults();
    } else {
      if (
        results.length === 0 &&
        event.query.length >= minSearchCharLen &&
        (event.query.length > this.editLine.length - 1 ||
          event.query.length > this.productSearch.length - 1)
      ) {
        //remove last character from the search and try again - Seems certain UPC products barcodes have an extra digit
        event.originalQuery = event.query;
        event.query = event.query.substr(0, event.query.length - 1);
        event.query = event.query.startsWith('*')
          ? event.query.substr(1)
          : event.query;
        this.searchProducts(event);
      } else {
        //If the search above returns no records, search the DB
        if (
          event.originalQuery ||
          event.query.length === this.editLine.length - 1 ||
          event.query.length === this.productSearch.length - 1
        ) {
          event.query = event.originalQuery ? event.originalQuery : event.query;
          if (event.originalQuery) {
            delete event.originalQuery;
          }
          this.searchAPI(event);
        } else {
          this.searchResult = [];
        }
      }
    }
  }

  switchViewExternal(event) {
    if (this.searchExternalFlag && this.productSearch) {
      this.searchProducts(this.searchExternalValue);
    }
  }

  searchAPI(event) {
    if (!this.searchExternalFlag) {
      event.query = event.query.startsWith('*')
        ? event.query.substr(1)
        : event.query;
      event.query = event.query.endsWith('*')
        ? event.query.substr(0, event.query.length - 1)
        : event.query;
      this.productsService
        .searchProductV2(this.partnerID, event.query)
        .subscribe(
          (results) => {
            if (this.partner.AllowExactMatchingOnQuote && results.ExactMatch) {
              var item = results.products[0];
              this.addLineItemAuto({
                ID: item.ID,
                SKU: item.Description,
                Name: item.Data,
                Quantity: 1,
                Discount: 0,
                DiscountID: 0,
                FoundInPOS: true,
              });
            } else if (
              results.products.length === 0 &&
              event.query.length >= minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              event.query = event.query.startsWith('*')
                ? event.query.substr(1)
                : event.query;
              this.searchProducts(event);
            } else {
              this.searchResult = results.products.map((item) => {
                return {
                  ID: item.ID,
                  SKU: item.Description,
                  Name: item.Data,
                  UnitPrice: item.UnitPrice,
                  UnitPrice_IncludingTax: item.UnitPrice_IncludingTax,
                  Quantity: 1,
                  Discount: 0,
                  DiscountID: 0,
                  FoundInPOS: true,
                };
              });
              setTimeout(() => {
                this.getQuantitiesLocked = false;
              }, 200);
            }
          },
          (err) => {
            if (
              err &&
              event.query.length >= minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              event.query = event.query.startsWith('*')
                ? event.query.substr(1)
                : event.query;
              this.searchProducts(event);
            }
          },
        );
    } else {
      this.productsService
        .searchExternalProduct(this.partnerID, event.query)
        .subscribe(
          (results) => {
            if (
              results.products.length === 0 &&
              event.query.length >= minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              event.query = event.query.startsWith('*')
                ? event.query.substr(1)
                : event.query;
              this.searchProducts(event);
            } else {
              this.searchResult = JSON.parse(
                JSON.stringify(results.products),
              ).map((product) => {
                product.SupplierID = product.PartnerID;
                product.InternalProductID = JSON.parse(
                  JSON.stringify(product),
                ).ID;
                product.ID = 0;
                product.Quantity = 1;
                product.Discount = 0;
                product.DiscountID = 0;
                product.FoundInPOS = true;
                product.OriginalUnitPrice = JSON.parse(
                  JSON.stringify(product),
                ).UnitPrice;
                delete product.PartnerID;
                return product;
              });
              setTimeout(() => {
                this.getQuantitiesLocked = false;
              }, 200);
            }
          },
          (err) => {
            if (
              err &&
              event.query.length >= minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              event.query = event.query.startsWith('*')
                ? event.query.substr(1)
                : event.query;
              this.searchProducts(event);
            }
          },
        );
    }
  }

  filterList(q, list) {
    function escapeRegExp(s) {
      return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    const words = q
      .split(/\s+/g)
      .map((s) => s.trim().toLowerCase())
      .filter((s) => !!s);

    const hasTrailingSpace = q.endsWith(' ');
    const searchRegex = new RegExp(
      words
        .map((word, i) => {
          if (words.length === 1) {
            return `(.*${escapeRegExp(word)}.*)`;
          } else {
            return `(?=.*\\b${escapeRegExp(word)})`;
          }
        })
        .join(''),
      'i',
    );

    var resultList = list.filter((item) => {
      return searchRegex.test(item.Name);
    });

    resultList.forEach((res) => {
      var nameArray = res.Name.split(' ');
      var count = 0;
      nameArray.forEach((name) => {
        if (words.includes(name.toLowerCase())) {
          count += 1;
        }
      });
      res.wordMatch = count;
    });

    resultList = resultList.sort((a, b) => {
      if (a.wordMatch > b.wordMatch) {
        return -1;
      } else if (a.wordMatch < b.wordMatch) {
        return 1;
      } else {
        return 0;
      }
    });

    return resultList;
  }

  skuSelected(event) {
    if (
      event.SKU &&
      (!event.UnitPrice || event.InternalProductID === undefined)
    ) {
      this.productsService
        .searchInvoiceProduct(this.partnerID, event.SKU)
        .subscribe((result) => {
          let products = result.filter((item) => {
            return item.Name === event.Name;
          });
          if (products.length > 0) {
            let product = products[0];
            product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
            product.ID = 0;
            product.Quantity = 1;
            product.Discount = 0;
            product.DiscountID = 0;
            product.FoundInPOS = true;
            product.OriginalUnitPrice = JSON.parse(
              JSON.stringify(product),
            ).UnitPrice;
            delete product.PartnerID;
            this.editLine = product;
          }
        });
    }
    setTimeout(() => {
      this.quantityComponent.nativeElement.focus();
    }, 500);
  }

  addLineItemAuto(event) {
    if (
      event.keyCode &&
      (event.originalEvent.keyCode === 13 || event.keyCode === 13)
    ) {
      event.preventDefault();
      return;
    }
    if (event.value) {
      event = event.value;
    }
    if (event.SKU && !event.InternalProductID) {
      this.productsService
        .searchInvoiceProduct(this.partnerID, event.SKU)
        .subscribe((result) => {
          let products = result.filter((item) => {
            return item.Name === event.Name;
          });
          if (products.length > 0) {
            let product = products[0];
            product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
            product.ID = 0;
            product.Quantity = 1;
            product.Discount = 0;
            product.DiscountID = 0;
            product.FoundInPOS = true;
            product.OriginalUnitPrice = JSON.parse(
              JSON.stringify(product),
            ).UnitPrice;
            delete product.PartnerID;

            this.editing = true;
            this.editLine = product;
            this.invoice.LineItems.push(product);
            this.sent = false;
            //setTimeout(() => this.quantityComponent.nativeElement.focus(), 500);
            this.updateLine(this.invoice.LineItems.length - 1);
            this.productSearch = '';
          }
        });
    } else {
      let product = event;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.FoundInPOS = true;
      product.OriginalUnitPrice = product.UnitPrice;
      product.edit = true;
      delete product.PartnerID;

      this.editing = true;
      this.editLine = product;
      this.invoice.LineItems.push(product);
      this.sent = false;
      //setTimeout(() => this.quantityComponent.nativeElement.focus(), 500);
      this.updateLine(this.invoice.LineItems.length - 1);
      this.productSearch = '';
    }
  }

  addLineItem() {
    if (this.invoice && this.invoice.LineItems) {
      this.editing = true;
      this.editLine = {};
      this.invoice.LineItems.push({ edit: true });
      this.sent = false;
      setTimeout(() => {
        //       this.lineItemProductSearchComponent.focusInput();
      }, 500);
    }
  }

  editLineItem(index) {
    this.editing = true;
    this.invoice.LineItems[index].edit = true;
    this.editLine = this.invoice.LineItems[index];
    this.sent = false;
    setTimeout(() => this.quantityComponent.nativeElement.focus(), 500);
  }

  deleteLineItem(index) {
    this.updatingQuote = true;
    this.editing = true;
    this.invoiceService
      .deleteLineItem(this.invoice.ID, this.invoice.LineItems[index].ID)
      .subscribe(
        (invoice) => {
          this.reuseStockOnHand(invoice);

          this.disablePOS =
            this.invoice.LineItems.findIndex((x) => !x.Approved) > -1 &&
            this.invoice.SentApproval;
          this.updatingQuote = false;
          this.editing = false;

          this.manageInvoicePOSExtras();
        },
        (err) => {
          this.updatingQuote = false;
          this.editing = false;
        },
      );
  }

  updateLine(index) {
    this.editing = false;
    this.invoice.LineItems[index] = this.editLine;
    this.invoice.LineItems[index].Price =
      this.invoice.LineItems[index].Quantity *
      this.invoice.LineItems[index].UnitPrice;
    delete this.invoice.LineItems[index].edit;
    //this.saveQuote();
    this.saveLineItem(this.invoice.LineItems[index]);
  }

  saveLineItem(lineItem) {
    if (lineItem.value) {
      lineItem = { lineItem, ...lineItem.value };
      delete lineItem['value'];
    }

    this.updatingQuote = true;
    this.editing = true;
    lineItem.LightSpeedDiscounts = this.lightSpeedDiscounts;

    if (lineItem.ID) {
      this.invoiceService.updateLineItem(lineItem).subscribe(
        (invoice) => {
          this.reuseStockOnHand(invoice);
          this.updatingQuote = false;
          this.editing = false;
          this.manageInvoicePOSExtras();
        },
        (err) => {
          this.updatingQuote = false;
          this.editing = false;
        },
      );
    } else {
      lineItem.InvoiceID = this.invoice.ID;
      this.invoiceService.addLineItem(lineItem).subscribe(
        (invoice) => {
          this.reuseStockOnHand(invoice);
          this.updatingQuote = false;
          this.editing = false;
          this.manageInvoicePOSExtras();
          setTimeout(() => {
            //       this.productSearchComponent.focusInput();
            if (
              this.productSearchComponent.inputEL &&
              this.productSearchComponent.inputEL.nativeElement
            ) {
              const inputElement =
                this.productSearchComponent.inputEL.nativeElement;
              this.renderer.selectRootElement(inputElement).focus();
            }
          }, 500);
        },
        (err) => {
          this.updatingQuote = false;
          this.editing = false;
        },
      );
    }
  }

  //This reuses the stock on hand while the other API fetches the new stock. Without this, its keeps jumping to 0 or - while its inbetween waiting
  reuseStockOnHand(invoice) {
    invoice.LineItems.forEach((lineItem) => {
      var oldItem = this.invoice.LineItems.filter((x) => {
        return x.ID == lineItem.ID;
      }).pop();
      if (oldItem) {
        lineItem.StockOnHand = oldItem.StockOnHand;
      }
      lineItem.LineItemNoteUpdate = lineItem.LineItemNote;
    });
    this.invoice = invoice;
  }

  promptSpecialOrder() {
    this.confirmationService.confirm({
      message: this.translate.instant('bikeshop.special_orders_question'),
      key: 'quote-order-confirmation',
      accept: () => {
        this.openSpecialOrderPOS();
      },
    });
  }

  openSpecialOrderPOS() {
    this.specialOrderItems = this.invoice.LineItems.filter((x) => {
      return x.SendToPOS;
    }).map((x) => {
      return x.ID;
    });
    this.sendToPOS(false, () => {
      this.getInvoice(() => {
        this.serviceRequest
          .waitingForParts(this.jobcard.ID)
          .subscribe((jobcard) => {

            if (this.useWorkOrdersForWorkshop) {
              this.checkWindow();
            } else if (
              !this.useWorkOrdersForWorkshop &&
              this.invoice.ExternalKey !== null &&
              this.invoice.ExternalKey !== ''
            ) {
              var url =
                'https://us.merchantos.com/register.php?form_name=load_transaction&transaction_id=' +
                this.invoice.ExternalKey;
              if (
                this.partner.POSCustomURL &&
                this.partner.POSCustomURL.indexOf('{{SALEID}}') > -1
              ) {
                url = this.partner.POSCustomURL.replace(
                  '{{SALEID}}',
                  this.invoice.ExternalKey,
                );
              }

              this.popupWindow = window.open(
                url,
                'LightSpeed Sale',
                'toolbar=0,scrollbars=1,location=0,statusbar=1,menubar=0,resizable=0,width=1200,height=720',
              );
              this.checkWindow();
            }
          });
      });
    });
  }

  sendToPOS(manageStock, callback) {
    this.showTakingTooLong = false;
    this.sendingToPOS = true;
    setTimeout(() => {
      if (this.sendToPOS) {
        this.showTakingTooLong = true;
      }
    }, 5000);
    this.invoiceService
      .sendInvoiceToPOS(
        this.invoice.ID,
        this.specialOrderItems && this.specialOrderItems.length > 0
          ? this.specialOrderItems
          : null,
      )
      .subscribe(
        (invoice) => {
          this.selectItemsForSpecialOrder = false;
          this.specialOrderItems = [];
          this.handleGetInvoice(null, invoice);
          if (this.helpersService.getPartnerData().POSSystemID === Pos.SAGE) {
            var externalKeysSynced = true;
            invoice.LineItems.forEach((lineItem) => {
              if (
                lineItem.ExternalKey === null ||
                lineItem.ExternalKey.length === 0
              ) {
                externalKeysSynced = false;
              }
            });
            if (!externalKeysSynced) {
              this.invoiceService.saveInvoiceZA(this.invoice, true).subscribe(
                (invoiceZA) => {
                  externalKeysSynced = true;
                  invoiceZA.LineItems.forEach((lineItem) => {
                    if (
                      lineItem.ExternalKey === null ||
                      lineItem.ExternalKey.length === 0
                    ) {
                      externalKeysSynced = false;
                    }
                  });
                  if (!externalKeysSynced) {
                    this.getInvoice(() => {
                      return;
                    });
                    this.sendingToPOS = false;
                    this.showTakingTooLong = false;
                    this.messageService.add({
                      life: 5000,
                      detail:
                        this.translate.instant(
                          'bikeshop.modal.update_job_card.quote.message_pos_not_updated',
                        ) +
                        ' ' +
                        invoiceZA.Errors.join(' and '),
                    });
                  } else {
                    this.sendingToPOS = false;
                    this.showTakingTooLong = false;
                    this.sentToPosMessage(
                      this.translate.instant(
                        this.useWorkOrdersForWorkshop ? 'bikeshop.workshop.jobcard.work_order_synced' :
                          'bikeshop.modal.update_job_card.quote.message_pos_updated',
                      ),
                    );
                    if (callback) {
                      callback();
                    }
                  }
                },
                (error) => {
                  this.sendingToPOS = false;
                  this.showTakingTooLong = false;
                  this.getInvoice(() => {
                    return;
                  });
                  this.messageService.add({
                    life: 5000,
                    detail:
                      this.translate.instant(
                        'bikeshop.modal.update_job_card.quote.message_pos_not_updated',
                      ) + invoice.Errors.join(' and '),
                  });
                },
              );
            } else {
              this.sendingToPOS = false;
              this.showTakingTooLong = false;
              this.sentToPosMessage(
                this.translate.instant(
                  'bikeshop.modal.update_job_card.quote.message_pos_updated',
                ),
              );
              if (callback) {
                callback();
              }
            }
          } else if (
            this.invoice.ExternalKey &&
            (invoice.Errors === null || invoice.Errors.length === 0)
          ) {
            this.sendingToPOS = false;
            this.showTakingTooLong = false;
            this.sentToPosMessage(
              this.translate.instant(
                callback
                  ? (this.useWorkOrdersForWorkshop ? 'bikeshop.workshop.jobcard.special_order_synced' : 'bikeshop.modal.update_job_card.quote.order_message')
                  : this.useWorkOrdersForWorkshop ? 'bikeshop.workshop.jobcard.work_order_synced'
                    : 'bikeshop.modal.update_job_card.quote.message_pos_updated',
              ),
            );
            if (callback) {
              callback();
            }
          } else {
            this.translate
              .get(
                'bikeshop.modal.update_job_card.quote.message_pos_not_updated',
              )
              .subscribe((msg) => {
                var m = msg + ' ' + invoice.Errors.join(' and ');
                this.sentToPosMessage(m);
                if (callback) {
                  callback();
                }
              });
          }

          if (
            manageStock &&
            this.partner.ManageStock &&
            this.partner.AddStockBackAtSendToPOS &&
            this.partner.POSSystemID === 6
          ) {
            setTimeout(() => {
              this.inventoryService
                .addBackStockFromQuote(this.partnerID, this.jobcard.ID)
                .subscribe((result) => { });
            }, 2000);
          }

          this.getInvoice(() => { }, true);
        },
        (err) => {
          this.sendingToPOS = false;
          this.showTakingTooLong = false;
          if (callback) {
            callback();
          }
          console.log(err);
        },
      );
  }

  createSalesOrder(manageStock, callback) {
    this.showTakingTooLong = false;
    this.sendingToPOS = true;
    setTimeout(() => {
      if (this.sendToPOS) {
        this.showTakingTooLong = true;
      }
    }, 5000);
    this.invoiceService
      .sendInvoiceToPOSAsSalesOrder(
        this.invoice.ID,
        this.specialOrderItems && this.specialOrderItems.length > 0
          ? this.specialOrderItems
          : null,
      )
      .subscribe(
        (invoice) => {
          this.selectItemsForSpecialOrder = false;
          this.sendingToPOS = false;
          this.showTakingTooLong = false;
          this.sentToPosMessage(
            this.translate.instant(
              'bikeshop.modal.update_job_card.quote.message_pos_updated',
            ),
          );
        },
        (err) => {
          this.sendingToPOS = false;
          this.showTakingTooLong = false;
          if (callback) {
            callback();
          }
        },
      );
  }

  sentToPosMessage(message) {
    this.getInvoice(() => {
      return;
    });
    this.messageService.add({
      life: 5000,
      detail: message,
    });
  }

  sendForApproval() {
    const partner = this.helpersService.getPartnerData();
    this.editing = true;
    this.userService
      .postAskApproval(
        partner.ID,
        this.jobcard.CyclistID,
        'Your invoice has been updated',
        `${partner.Name} has added an item on your pending quote and would like your approval`,
        '/cyclist/jobcard-approval/' + this.jobcard.ID + '?Theme=' + partner.ID,
        this.jobcard.ID,
        this.jobcard.ThirdPartyID == null ? null : this.sendToThirdPartyOnly,
      )
      .subscribe((res) => {
        this.editing = false;
        this.sent = true;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant('Asked for approval'),
        });
      });
  }

  syncPOS() {
    this.syncingPOS = true;
    //this.posIntegrationService.startPOSSync(this.partnerID).subscribe(
    //  (syncRes) => {
    this.productsService.getAllProducts(this.partnerID).subscribe(
      (products) => {
        this.helpersService.saveProductData(products);
        this.products = products;

        this.syncingPOS = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.quote.pos_sync_complete',
          ),
        });
      },
      (err) => {
        this.syncingPOS = false;
      },
    );
    //  },
    //  (err) => {
    //    this.syncingPOS = false;
    //  }
    //);
  }

  updateCouponCode(event) {
    if (this.discountCode && this.discountCode.length > 0) {
      var data = {
        PartnerID: this.partnerID,
        CouponCode: this.discountCode,
        UserID: this.jobcard.CyclistID,
        SelectedServiceTypes: this.jobcard.Types.map((type) => {
          return type.TypeID;
        }),
      };
      this.couponsService.validateCouponCode(data).subscribe(
        (res) => {
          this.jobcard.CouponCode = this.discountCode;
          this.jobcard.ExternalVoucherCode = '';
          this.saveCouponService(event, 'COUPON');
        },
        (err) => {
          if (err.status === 404) {
            this.jobcard.ExternalVoucherCode = this.discountCode;
            this.jobcard.CouponCode = '';
            this.saveCouponService(event, 'EXT_VOUCHER_CODE');
          } else {
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(err.error.message),
            });
          }
        },
      );
    } else {
      this.jobcard.ExternalVoucherCode = '';
      this.jobcard.CouponCode = '';
      this.saveCouponService(event, 'COUPON');
    }
  }

  updateExternalVoucherCode(event) {
    if (this.jobcard.ExternalVoucherCode) {
      this.saveCouponService(event, 'EXT_VOUCHER_CODE');
    }
  }

  saveCouponService(event, type) {
    var jobcard = JSON.parse(JSON.stringify(this.jobcard));
    jobcard.DateCheckedIn = new Date(
      moment(this.jobcard.DateCheckedIn).format('YYYY-MM-DDTHH:mm') + 'Z',
    );
    jobcard.DateRequiredBy = new Date(
      moment(this.jobcard.DateRequiredBy).format('YYYY-MM-DDTHH:mm') + 'Z',
    );
    this.serviceRequest.saveServiceRequest(jobcard).subscribe((result) => {
      this.messageService.add({
        life: 5000,
        detail: this.translate.instant(
          type === 'COUPON'
            ? 'bikeshop.modal.update_job_card.job_card.coupon_code_updated'
            : 'bikeshop.modal.update_job_card.job_card.external_discount_code_updated',
        ),
      });
      this.getInvoice(() => { });
      event.deactivate();
    });
  }

  openPOSURL() {
    switch (this.partner.POSSystemID) {
      case 6:
        if (
          this.partner.POSCustomURL &&
          this.partner.POSCustomURL.indexOf('{{SALEID}}') > -1
        ) {
          window.open(
            this.partner.POSCustomURL.replace(
              '{{SALEID}}',
              this.invoice.ExternalKey,
            ),
          );
        } else {
          window.open(
            'https://us.merchantos.com/register.php?form_name=load_transaction&transaction_id=' +
            this.invoice.ExternalKey,
          );
        }
        break;
      case 8:
        window.open(
          'https://go.xero.com/organisationlogin/default.aspx?shortcode=' +
          this.shortCode +
          '&redirecturl=/AccountsReceivable/View.aspx?InvoiceID=' +
          this.invoice.ExternalKey,
        );
        break;
      case 13:
        window.open(
          'https://pos2.citruslime.com/pos2/#/pos/registerSelection?orderId=' +
          this.invoice.ExternalKey,
        );
        break;
      case 16:
        window.open(
          'https://system.netsuite.com/app/accounting/transactions/custinvc.nl?id=' +
          this.invoice.ExternalKey +
          '&whence=',
        );
        break;
      case 19:
        window.open(
          `${this.partner.POSCustomURL}/#sales/orders/edit/${this.invoice.ExternalKey}`
        );
        break;
    }
  }

  openPOSURL_SalesOrder() {
    switch (this.partner.POSSystemID) {
      case 16:
        window.open(
          'https://system.netsuite.com/app/accounting/transactions/salesord.nl?id=' +
          this.invoice.SynchFeedback.split('|')[0] +
          '&whence=',
        );
        break;
    }
  }

  checkWindow() {
    setTimeout(() => {
      if (!this.popupWindow || this.popupWindow?.parent === null) {
        this.updatingQuote = true;
        this.specialOrdersService
          .getSpecialOrdersV2(this.partnerID, true)
          .subscribe((specialOrders) => {
            this.getInvoice(() => { });
          });
      } else {
        this.checkWindow();
      }
    }, 2000);
  }

  hasStock(lineItem) {
    return lineItem.StockOnHand && lineItem.StockOnHand > 0;
  }

  enableSpecialOrderItemSelection() {
    this.invoice.LineItems.forEach((lineItem) => {
      if (lineItem.ExternalKey && lineItem.ExternalKey.length > 0) {
        lineItem.SendToPOS = false;
      }
    });
    this.selectItemsForSpecialOrder = true;
  }

  checkSpecialOrderItemsSelected() {
    return (
      this.invoice.LineItems.filter((x) => x.SendToPOS === true).length > 0
    );
  }

  updateLineItemNote(lineItem, event) {
    event.hide();
    lineItem.LineItemNote = lineItem.LineItemNoteUpdate;
    this.updatingQuote = true;
    this.editing = true;
    lineItem.LightSpeedDiscounts = this.lightSpeedDiscounts;

    if (lineItem.ID) {
      this.invoiceService.UpdateInvoiceLineItemNote(lineItem).subscribe(
        (invoice) => {
          this.updatingQuote = false;
          this.editing = false;
        },
        (err) => {
          this.updatingQuote = false;
          this.editing = false;
        },
      );
    }
  }

  getSupplierInfo(product) {
    if (
      product &&
      product.SupplierID &&
      this.appConfig.getSupplierInfo(product.SupplierID)
    ) {
      return this.appConfig.getSupplierInfo(product.SupplierID);
    } else {
      return { name: '', color: '#000000' };
    }
  }

  productPanelVisible() {
    this.showProductPanel = true;
  }

  productPanelHidden() {
    this.showProductPanel = false;
  }

  @ViewChild('addProductOverlay') addProductOverlay: OverlayPanel;

  newProductAdded(product) {
    const lineItem = {
      ID: 0,
      InternalProductID: product.id,
      SKU: product.sku,
      Name: product.name,
      Brand: product.brand,
      Description: product.name,
      Quantity: 1,
      UnitPrice: product.unitPrice,
      tax: product.tax,
      UnitPrice_IncludingTax: product.unitPrice_IncludingTax,
      Discount: 0,
      DiscountID: 0,
      ExternalKey: null,
      ExternalProductID: null,
    };
    this.saveLineItem(lineItem);
    setTimeout(() => {
      this.addProductOverlay.hide();
      this.syncPOS();
    }, 250);
  }

  trackByFn(index, item) {
    return index;
  }

  getItemPricesGroups() {
    this.invoiceService
      .getItemPricesGroups(this.partnerID)
      .subscribe((results) => {
        console.log(results);
        if (results == null) return;
        results.ProductGroups.forEach((x) => {
          this.priceGroups.push({ value: x.ID, label: x.Name });
        });
        //  this.priceGroups = result
        //    .map(x => { return { value: x.ID, label: x.Name } })
        //});
      });
  }

  updateLineItemPricesByGroup() {
    this.updatingQuote = true;
    this.editing = true;

    this.invoiceService
      .updateLineItemPricesByGroup(this.invoice.ID, this.priceGroup)
      .subscribe(
        (invoice) => {
          //this.invoice = invoice;
          this.getInvoice(() => {
            this.getInvoice(() => {
              return;
            }, true);
            return;
          }, false);
          this.updatingQuote = false;
          this.editing = false;
        },
        (err) => {
          this.updatingQuote = false;
          this.editing = false;
        },
      );
  }

  openWorkOrderURL() {
    switch (this.partner.POSSystemID) {
      case 6:
        window.open(
          `https://us.merchantos.com/?name=workbench.views.beta_workorder&form_name=view&id=${this.invoice.WorkOrderID}&tab=details`
        );
        break;
    }
  }

  canEditLineItemQuantity(lineItem) {
    return !(lineItem.InternalProductID == 0 && lineItem.ExternalKey !== null && lineItem.ExternalKey !== '' && lineItem.IsLabor);
  }
}
